import React from "react";
import { Box, styled } from "@mui/material";
import { MainBg } from "../../assets/images";

/** Dark surface behind hero copy when the background image is off or failed to load (contrast for white text). */
const HEADLINE_BG_FALLBACK = "#1a1a1a";

const HeadlineBox = styled(Box)(({ theme }) => ({
  backgroundColor: HEADLINE_BG_FALLBACK,
  backgroundImage: `url(${MainBg})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  backgroundAttachment: "scroll",
  backgroundSize: "cover",
  textAlign: "center",
  borderBottom: `3px solid ${theme.palette.primary.main}`,
}));

const HeadlineBody = styled(Box)({
  padding: "120px 0",
});

type HeadlineProps = {
  children: React.ReactNode;
  marginBottom?: number;
};

const Headline: React.FC<HeadlineProps> = ({ children, marginBottom = 2 }) => {
  return (
    <HeadlineBox mb={marginBottom}>
      <HeadlineBody>{children}</HeadlineBody>
    </HeadlineBox>
  );
};

export default Headline;

